import type { PropsWithChildren } from "react";
import { createContext } from "react";
import type { ClientConfig } from "./getClientConfig.ts";

export const ClientConfigContext = createContext<ClientConfig | null>(null);

export const ClientConfigProvider = ({
  children,
  config,
}: PropsWithChildren<{
  config: ClientConfig;
}>) => {
  return (
    <ClientConfigContext.Provider value={config}>
      {children}
    </ClientConfigContext.Provider>
  );
};
